import React from "react";
import Modal from "../../components/Modal";
import i18n from "../../i18n";
import TouchEffect from "../../components/TouchEffect/TouchEffect";

export default class RulesModal extends Modal {
  handleContinueButtonClick = () => {
    this.props.onContinue && this.props.onContinue();
    this.dismiss();
  };

  renderModal() {
    return <React.Fragment>
      <h1 dangerouslySetInnerHTML={{__html: i18n.t("rules_modal__title")}} />

      <ul>
        <li dangerouslySetInnerHTML={{__html: i18n.t("rules_modal__list_text_1")}} />
        <li dangerouslySetInnerHTML={{__html: i18n.t("rules_modal__list_text_2")}} />
        <li dangerouslySetInnerHTML={{__html: i18n.t("rules_modal__list_text_3")}} />
      </ul>

      <p dangerouslySetInnerHTML={{__html: i18n.t("rules_modal__text")}} />

      <button onClick={this.handleContinueButtonClick}>
        {i18n.t("rules_modal__accept")}
        <TouchEffect />
      </button>
    </React.Fragment>;
  }
}